import { Outlet } from "react-router-dom";
import styles from "./Accounts.module.css";

export const AccountLayout = () => {
  return (
    <div className={`${styles.container} fade-in`}>
      <Outlet />
    </div>
  );
};
